module.exports = __webpack_public_path__ + "img/430x590px.99239690.png";